<section class="p-5" contenteditable="true">
    <div class="p-3 sen-fs12 border">Dear Sir or Madam,
        <br><br>
        Thank you for your interest in our products and services.
        <br><br>
        You will find our non-binding offer for a solar generator in the system.
        <br><br>
        For further information please contact us at any time.
        <br><br>
        We hope to make you an attractive offer and look forward to further discussions.
        <br><br><br>
        Best regards<br>
        ________________
    </div>
</section>